import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Renders article markdown with WANM-styled typography.
export function RichText({ children }) {
  return (
    <div className="wanm-prose" data-testid="article-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h2 className="text-3xl md:text-4xl font-black text-wanm-dark mt-12 mb-4" {...p} />,
          h2: ({ node, ...p }) => <h2 className="text-3xl font-black text-wanm-dark mt-12 mb-4" {...p} />,
          h3: ({ node, ...p }) => <h3 className="text-2xl font-black text-wanm-dark mt-8 mb-3" {...p} />,
          p: ({ node, ...p }) => <p className="text-lg md:text-xl text-wanm-dark/80 leading-relaxed mb-6" {...p} />,
          a: ({ node, ...p }) => <a className="text-wanm-red font-bold underline underline-offset-2" target="_blank" rel="noopener noreferrer" {...p} />,
          ul: ({ node, ...p }) => <ul className="mb-6 space-y-2 list-disc pl-6" {...p} />,
          ol: ({ node, ...p }) => <ol className="mb-6 space-y-2 list-decimal pl-6" {...p} />,
          li: ({ node, ...p }) => <li className="text-lg text-wanm-dark/80 leading-relaxed marker:text-wanm-pink" {...p} />,
          img: ({ node, ...p }) => <img className="rounded-2xl w-full my-8" alt={p.alt || ""} {...p} />,
          blockquote: ({ node, ...p }) => <blockquote className="border-l-4 border-wanm-pink pl-6 italic text-xl text-wanm-dark/70 my-8" {...p} />,
          strong: ({ node, ...p }) => <strong className="font-black text-wanm-dark" {...p} />,
          hr: () => <hr className="my-10 border-wanm-offwhite" />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}

export default RichText;
